module.exports = __webpack_public_path__ + "img/user.055a9197.png";